export default __webpack_public_path__ + "staticlp3/media/banner-2-item-1.4cb0b082.png";